export default function ServicesSection() {
  return (
    <section className="w-full bg-background-50 px-10 md:px-16 lg:px-20 py-20 md:py-28" aria-labelledby="services-heading">
      {/* Top zone: title left, subtitle right */}
      <div className="flex flex-col lg:flex-row lg:items-start gap-8 lg:gap-0 mb-16 md:mb-20">
        <h2 id="services-heading" className="font-sans text-3xl md:text-4xl lg:text-5xl text-foreground-950 font-bold leading-tight lg:w-[55%]">
          Engineering<br />Disciplines
        </h2>
        <p className="text-sm md:text-base text-foreground-500 font-body font-light leading-relaxed lg:w-[40%]">
          Our team applies rigorous engineering practices across three core disciplines, each essential to delivering reliable and scalable software solutions.
        </p>
      </div>

      {/* Three modules */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[1.25fr_1fr_1fr] gap-6">
        {/* Card 1 - wider, Architecture & Design */}
        <div className="bg-background-200/70 rounded-lg overflow-hidden">
          <div className="h-52 md:h-60 relative">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20minimalist%20geometric%20composition%20with%20layered%20rectangles%20and%20connecting%20lines%20in%20warm%20charcoal%20and%20cream%20tones%2C%20architectural%20blueprint%20aesthetic%2C%20clean%20structured%20design%2C%20no%20text%2C%20technical%20drawing%20style%20evoking%20system%20architecture%20planning&width=600&height=480&seq=sivora-svc-arch&orientation=landscape"
              alt="Abstract geometric composition representing system architecture and design"
              title="Architecture and Design"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="p-8">
            <h3 className="font-sans text-lg font-semibold text-foreground-900">Architecture &amp; Design</h3>
            <p className="mt-3 text-sm text-foreground-500 font-body font-light leading-relaxed">
              Defining system structure, component boundaries, and technical strategy to create foundations that support growth and evolution without compromising integrity.
            </p>
          </div>
        </div>

        {/* Card 2 - Development */}
        <div className="bg-background-200/70 rounded-lg overflow-hidden flex flex-col">
          <div className="p-8">
            <h3 className="font-sans text-lg font-semibold text-foreground-900 text-center">Development</h3>
          </div>
          <div className="h-52 md:h-60 relative">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20pattern%20of%20interlocking%20hexagons%20and%20nodes%20in%20warm%20gray%20and%20charcoal%20tones%20on%20light%20background%2C%20clean%20mathematical%20design%2C%20no%20text%2C%20network%20topology%20inspired%20visual%20representing%20code%20structure%20and%20development&width=400&height=400&seq=sivora-svc-dev&orientation=squarish"
              alt="Abstract geometric pattern representing software development"
              title="Development"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="p-8">
            <p className="text-sm text-foreground-500 font-body font-light leading-relaxed text-center">
              Implementing robust, well-tested code with clean patterns, consistent standards, and careful attention to edge cases and long-term maintainability.
            </p>
          </div>
        </div>

        {/* Card 3 - Quality Assurance */}
        <div className="bg-background-200/70 rounded-lg overflow-hidden flex flex-col">
          <div className="p-8">
            <h3 className="font-sans text-lg font-semibold text-foreground-900 text-center">Quality Assurance</h3>
          </div>
          <div className="h-52 md:h-60 relative">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20concentric%20circles%20and%20precision%20grid%20lines%20in%20warm%20gray%20and%20soft%20cream%20tones%2C%20minimalist%20scientific%20diagram%20style%2C%20clean%20structured%20layout%2C%20no%20text%2C%20evoking%20testing%20and%20quality%20measurement%20concepts&width=400&height=400&seq=sivora-svc-qa&orientation=squarish"
              alt="Abstract geometric pattern representing quality assurance and testing"
              title="Quality Assurance"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="p-8">
            <p className="text-sm text-foreground-500 font-body font-light leading-relaxed text-center">
              Systematic verification, performance profiling, and stability testing to ensure every release meets the highest standards of reliability.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}